// extracted by mini-css-extract-plugin
export default {"app":"app__2+Sbz","text-center":"text-center__NBYnR","error-color":"error-color__TIHtH","loading":"loading__IICia","wrapper":"wrapper__iFBGG"};